document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const header = document.querySelector('[data-header]');
  const t = document.querySelector('[data-menu-toggle]');
  const m = document.querySelector('[data-mobile-nav]');

  const setMenuState = (open) => {
    if (!t || !m) return;
    t.setAttribute('aria-expanded', String(open));
    const label = open
      ? (t.getAttribute('data-close-label') || 'Close menu')
      : (t.getAttribute('data-open-label') || 'Open menu');
    t.setAttribute('aria-label', label);
    m.classList.toggle('is-open', open);
    document.body.classList.toggle('menu-open', open);
    if (open && header) {
      header.classList.remove('header-hidden');
    }
  };

  if (t && m) {
    t.addEventListener('click', () => {
      const isOpen = t.getAttribute('aria-expanded') === 'true';
      setMenuState(!isOpen);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('menu-open')) {
        setMenuState(false);
        t.focus();
      }
    });

    m.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        setMenuState(false);
      });
    });
  }

  let lastScrollY = Math.max(0, window.scrollY);
  let ticking = false;
  const SCROLL_DELTA = 6;
  const TOP_THRESHOLD = 20;

  const updateNavbar = () => {
    const currentScrollY = Math.max(0, window.scrollY);
    const isMenuOpen = document.body.classList.contains('menu-open');

    if (header) {
      header.classList.toggle('scrolled', currentScrollY > 18);

      if (isMenuOpen) {
        header.classList.remove('header-hidden');
      } else if (currentScrollY <= TOP_THRESHOLD) {
        header.classList.remove('header-hidden');
      } else if (Math.abs(currentScrollY - lastScrollY) > SCROLL_DELTA) {
        if (currentScrollY > lastScrollY) {
          header.classList.add('header-hidden');
        } else {
          header.classList.remove('header-hidden');
        }
      }
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(updateNavbar);
      ticking = true;
    }
  };

  updateNavbar();
  window.addEventListener('scroll', onScroll, { passive: true });

  // HTML-validate preview banner: offset fixed header so logo isn't clipped
  const ban=document.querySelector('.validate-banner');
  if(ban){
    const setOffset=()=>document.documentElement.style.setProperty('--validate-offset',ban.offsetHeight+'px');
    setOffset();
    addEventListener('resize',setOffset,{passive:true});
    if(typeof ResizeObserver!=='undefined') new ResizeObserver(setOffset).observe(ban);
  }

  // Scroll effect is strictly integrated for the navbar section only
});

